import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

export default class Citation {
  constructor(el) {
    this.el = el
    this.text = this.el.querySelector('.citation--text')
    this.init()
  }

  init() {
    this.initTextReveal()
  }

  // Apparition caractère par caractère façon machine à écrire
  initTextReveal() {
    if (!this.text) return

    // smartWrap: chaque mot reste groupé pour ne pas se couper en fin de ligne
    const split = new SplitText(this.text, { type: 'chars', smartWrap: true })
    gsap.set(split.chars, { autoAlpha: 0 })

    gsap.to(split.chars, {
      autoAlpha: 1,
      duration: 0,
      stagger: 0.05,
      ease: 'none',
      scrollTrigger: {
        trigger: this.text,
        start: 'top 80%',
        toggleActions: 'play none none none',
      },
    })
  }
}
